import React from 'react';

import CustomModal from '@app/components/UI/Modal/CustomModal';

interface LoginModalProps {
	modalVisible: boolean;
	setModalVisible: (e: boolean) => void;
}

const LoginModal: React.FC<LoginModalProps> = ({
	modalVisible,
	setModalVisible,
	children,
}) => {
	return (
		<CustomModal modalVisible={modalVisible} setModalVisible={setModalVisible}>
			{children}
		</CustomModal>
	);
};

export default LoginModal;
